export var MsgSubtypes;
(function (MsgSubtypes) {
    MsgSubtypes[MsgSubtypes["DRAW_TEXT_MSG"] = 1000] = "DRAW_TEXT_MSG";
    MsgSubtypes[MsgSubtypes["DRAW_MSG"] = 1001] = "DRAW_MSG";
    MsgSubtypes[MsgSubtypes["DRAWN_MSG"] = 1002] = "DRAWN_MSG";
    MsgSubtypes[MsgSubtypes["REMOVE_TEAMMEBER"] = 1003] = "REMOVE_TEAMMEBER";
})(MsgSubtypes || (MsgSubtypes = {}));
